import { html, LitElement } from "lit";
import { GlobalEvents } from "./domain/global-events.enum.js";

class VariantSelector extends LitElement {
	override connectedCallback(): void {
		super.connectedCallback();
		this.addEventListener("change", this.onChange.bind(this));
	}

	override disconnectedCallback(): void {
		super.disconnectedCallback();
		this.removeEventListener("change", this.onChange.bind(this));
	}

	private onChange(event: Event): void {
		const target = event.target as HTMLInputElement;
		if (target?.type === "radio" && target.name === "id") {
			const selectedVariantId = target.value;

			// Set url variant parameter
			const url = new URL(globalThis.location.href);
			url.searchParams.set("variant", selectedVariantId);
			globalThis.history.replaceState({}, "", url);

			document.body.dispatchEvent(new CustomEvent(GlobalEvents.ProductVariantChanged, { detail: { variantId: selectedVariantId } }));
		}
	}

	override render() {
		return html`<slot></slot>`;
	}
}

if (!customElements.get("y-variant-selector")) {
	customElements.define("y-variant-selector", VariantSelector);
}
